// Applies a theme to the document. Everything visual is driven by CSS
// variables in src/styles/theme.css keyed off these <html> attributes:
//   data-theme="light|dark"   the resolved appearance
//   data-accent="<id>"        the accent color

const DARK_QUERY = "(prefers-color-scheme: dark)";

function getDarkQuery() {
  if (typeof window === "undefined" || !window.matchMedia) return null;
  return window.matchMedia(DARK_QUERY);
}

export function systemPrefersDark() {
  return Boolean(getDarkQuery()?.matches);
}

export function resolveAppearance(appearance, prefersDark = systemPrefersDark()) {
  if (appearance === "system") return prefersDark ? "dark" : "light";
  return appearance === "dark" ? "dark" : "light";
}

// Calls `onChange(prefersDark)` when the OS appearance changes; returns an
// unsubscribe function.
export function watchSystemAppearance(onChange) {
  const query = getDarkQuery();
  if (!query) return () => {};
  const listener = (event) => onChange(event.matches);
  if (query.addEventListener) {
    query.addEventListener("change", listener);
    return () => query.removeEventListener("change", listener);
  }
  // Safari < 14
  query.addListener(listener);
  return () => query.removeListener(listener);
}

export function applyThemeToDocument(resolvedAppearance, accentColor) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (root.dataset.theme !== resolvedAppearance) {
    root.dataset.theme = resolvedAppearance;
  }
  if (root.dataset.accent !== accentColor) {
    root.dataset.accent = accentColor;
  }
  // Native form controls, scrollbars and autofill follow the appearance.
  root.style.colorScheme = resolvedAppearance;
}
